import { NetworkRequestConfig, NetworkResponse } from './types';
import { requestInterceptor_Axios, responseInterceptor_Axios } from './adapters/interceptor';

type OnFulfilled<V> = ((value: V) => V | Promise<V>) | null;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type OnRejected = (value: any) => any;

export function requestInterceptor(onFulfilled: OnFulfilled<NetworkRequestConfig>, onRejected?: OnRejected): void;
export function requestInterceptor(onFulfilled, onRejected) {
	requestInterceptor_Axios(onFulfilled, onRejected);
}

export function responseInterceptor(onFulfilled: OnFulfilled<NetworkResponse>, onRejected?: OnRejected): void;
export function responseInterceptor(onFulfilled, onRejected) {
	responseInterceptor_Axios(onFulfilled, onRejected);
}
